/* eslint-disable */
import { useEffect } from "react";
import { Form } from "react-final-form";
import useCustomerHook from "../../customers/useCustomerHook";
import FormComponent from "./paymentForm";
import InvoiceDetails from "./invoiceDetails";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const AddPaymentForm = ({ customers, isEdit, paymentDetails }) => {
  const user = window?.CURRENT_USER;
  const { id } = useParams();
  console.log("isEdit", id, paymentDetails);

  function transformInvoicePayload(data) {
    return {
      reference_number: data.reference_number || "",
      customer_id: data.customer?.value || null,
      payment_date: data.payment_date
        ? moment(data.payment_date).format("YYYY-MM-DD")
        : null,
      notes: data.notes || "",
      amount_received: data.amount_received || 0,
      payment_method: data.payment_method || "",
      payment_type: data.payment_type.value || "balance",
      invoice_id: data.invoice.value || null,
      user_id: user?.id || null,
    };
  }
  const getSeletedCustomer = (value) => {
    if (!value) return null;
    return {
      value: value.id,
      label: value?.user?.full_name,
      data: value,
    };
  };
  const getSeletedInvoice = (value) => {
    if (!value) return null;
    return {
      value: value.id,
      label: value.invoice_number,
      data: value,
    };
  };

  const getSelectedPaymentType = (value) => {
    if (!value) return null;
    return {
      value: value,
      label: value.charAt(0).toUpperCase() + value.slice(1).replace(/_/g, " "),
    };
  };
  const onSubmit = (values) => {
    const data = transformInvoicePayload(values);
    let payload = { ...data };
    if (values.attachment && values.attachment[0]) {
      payload = { ...payload, attachment: values.attachment[0] };
    } else {
      const { ...rest } = payload;
      payload = rest;
    }
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (key === "attachment" && value) {
        formData.append(key, value);
      } else if (key !== "attachment") {
        formData.append(key, value);
      }
    });

    const url = isEdit ? `/payments/api/${id}/` : "/payments/api/";
    const method = isEdit ? "PUT" : "POST";
    fetch(url, {
      method,
      body: formData,
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((res) => res.json())
      .then(() => {
        window.location.href = "/payments/";
      })
      .catch((err) => {
        console.error("Error adding product:", err);
      });
  };
  const initialValues = isEdit
    ? {
        ...paymentDetails,
        payment_type: getSelectedPaymentType(paymentDetails?.payment_type),
        customer: getSeletedCustomer(paymentDetails?.customer),
        invoice: getSeletedInvoice(paymentDetails?.invoice),
      }
    : {};
  console.log(initialValues?.payment_type, "initialValues");
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        ...initialValues,
        payment_type: initialValues?.payment_type,
        payment_date: paymentDetails?.payment_date
          ? new Date(initialValues?.payment_date)
          : new Date(),
      }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <FormComponent customers={customers} isEdit={isEdit} />
            </div>
            <div className="col-md-6">
              <InvoiceDetails />
            </div>
          </div>
        </form>
      )}
    />
  );
};

export default AddPaymentForm;
